// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>2</span>&nbsp;&nbsp;My God, my rock in whom I take refuge,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;my shield, the horn of my salvation and my stronghold.<br> </p> </div></div>";
// Exports
module.exports = code;